// Import the images at the TOP of the file
import grade6Image from '../assets/Grade6.png';
import grade9Image from '../assets/Grade9.png';
import grade10Image from '../assets/Grade10.png';
import grade11Image from '../assets/Grade11.png';
import grade12Image from '../assets/grade12.png';
// import csImage from '../assets/cs.jpg';

export const navLinks = [
  { id: 1, title: "Home", path: "/" },
  { id: 2, title: "Link Hub", path: "#", dropdown: true }, // Mark as dropdown
  { id: 3, title: "Scheme of Work", path: "/scheme-of-work" },
  { id: 4, title: "Services", path: "/services" },
];

// Link Hub dropdown items - simple external links
export const linkHubDropdown = [
  { 
    id: 1, 
    title: "Check TSC Registration Status", 
    url: "https://tsconline.tsc.go.ke/register/registration-status",
    type: "external",
    path: "/link-hub/tsc-registration"
  },
  { 
    id: 2, 
    title: "Teacher performance appraisal", 
    url: "https://tpad2.tsc.go.ke/auth/login",
    type: "external",
    path: "/link-hub/teacher-appraisal"
  },
  { 
    id: 3, 
    title: "TSC Online teachers Portal", 
    url: "https://hrmis.tsc.go.ke/tm-app/HOI",
    type: "external",
    path: "/link-hub/tsc-portal"
  },
  { 
    id: 4, 
    title: "Activate TSC Account", 
    url: "https://tpad2.tsc.go.ke/hoi_sys/auth/activate",
    type: "external",
    path: "/link-hub/activate-tsc"
  },
  { 
    id: 5, 
    title: "T-PAY Login", 
    url: "https://tpay.tsc.go.ke/fa392bf9a4692aa0cc/zln",
    type: "external",
    path: "/link-hub/tpay-login"
  },
  { 
    id: 6, 
    title: "KJSEA Registration portal", 
    url: "https://cbasa.knec.ac.ke/Account/LogOn?redirect=%2f",
    type: "external",
    path: "/link-hub/kjsea-registration"
  },
];


export const latestNews = [
  {
    id: 1,
    title: "A spanish scientist has cured pancreatic cancer in mice",
    date: "2026-01-24",
    excerpt: "Not a human cure yet. Spanish researchers have eliminated pancreatic cancer in mice, not people.",
    category: "Updates",
    image: "https://res.cloudinary.com/dqtzbgvug/image/upload/v1769806520/visnx4davsrqokalkaan.webp",
    fullContent: `Mariano Barbacid, who heads the Experimental Oncology Group at Spain’s National Cancer Research Centre (CNIO), led the research along with his team. Their therapy managed to eliminate pancreatic tumours in mice, something that has long been difficult to achieve. The study showed no major side effects, adding to the importance of the findings.

The research was published in the journal PNAS (Proceedings of the National Academy of Sciences). Many scientists and members of the public described it as a hopeful moment in tackling one of the deadliest forms of cancer. In January 2026, Barbacid and his group at the CNIO published a study in which a combination of three targeted inhibitors, the established drugs afatinib and daraxonrasib, and a research compound SD36, showed promise in treating pancreatic ductal adenocarcinoma in animal models. Not only was this new potential 'cure' able to completely wipe out existing pancreatic tumors, but it also showed no signs of relapse in the existing tests after treatment was conducted, proving it to be a potentially revolutionary treatment if the same results were seen in humans.

Pancreatic cancer is known for its resistance to treatment, making it incredibly challenging for doctors to deal with, yet this potential cure uses the triple-drug approach to fight three tumor survival mechanisms at the one time, effectively reducing what the cancer can do to 'rewire' itself as a defense tactic.`
  },
{
    id: 2,
    title: "6 Takeaways from ‘Melania,’ the Documentary About the First Lady",
    date: "2026-01-31",
    excerpt: "The film, which counts Melania Trump as a producer, touches on her immigrant roots, her love for her mother and her style, but there are few revelations.",
    category: "Policy",
    image: "https://res.cloudinary.com/dqtzbgvug/image/upload/v1769851388/apzjflymvj9iz0ejsfmy.jpg",
    fullContent: `“Melania,” the new documentary about the first lady, Melania Trump, may have been the subject of a huge $35 million marketing campaign, a high-wattage premiere at the Kennedy Center and widespread distribution in 1,500 theaters nationwide. What it didn’t have was a lot of deep access or context from outside voices.

Cameras rolled on Mrs. Trump — who is also a producer of the film — for 20 days last January, culminating in President Donald Trump’s second inauguration. That is fleetingly little time in a medium that usually takes years.

The brevity is presented as an asset in what purports to be fly-on-the-wall filmmaking. The director, Brett Ratner, who has been reportedly living in an eight-bedroom house at Mar-a-Lago, the Trumps’ Palm Beach, Fla., enclave, trails along with Mrs. Trump as she travels in a loop between Florida, New York and Washington, D.C., almost always alone and frequently in silence. She is private, even onscreen in her own movie.

Then again, little about the nearly two-hour film follows the conventions of nonfiction cinema, starting with the astronomical $40 million Amazon MGM paid to acquire it, from Melania Trump’s own production company. What does it capture about the life — or “the family, business and philanthropy,” as she puts it — of the frequently be-hatted two-time first lady?`
},
  {
    id: 3,
    title: "Newborn baby dies after mum not woken for heart rate check",
    date: "2026-01-31",
    excerpt: "Sonny died aged three days after suffering a severe brain injury caused by lack of oxygen and sepsis",
    category: "Resources",
    image: " https://res.cloudinary.com/dqtzbgvug/image/upload/v1769851637/hrp1gig85g0gxco2lhbu.webp",
    fullContent: `A newborn baby died after hospital staff failed to wake his mother for "potentially lifesaving observations" before his birth, an investigation has found.

Sonny Taylor was left "distressed for a significant amount of time" before a delayed emergency Caesarean at Ysbyty Gwynedd, Bangor, and died three days later from a severe brain injury caused by sepsis and lack of oxygen.

His parents Eve and Thomas said he was "badly let down when he needed help the most".

Betsi Cadwaladr University Health Board accepted the report's findings and apologised "unreservedly" for the failures in care. Tests later showed Sonny "had been distressed for a significant amount of time" and should have been delivered earlier, the report said.

He was transferred to a specialist neonatal intensive care unit, but after discussions with clinicians, Eve and Thomas agreed to move him to palliative care.

He died shortly after 19:00 on 3 October 2022, with his death recorded as brain injury caused by a lack of oxygen and sepsis.

Investigators said that if Sonny's heart rate had been identified as abnormal earlier, "this would likely have changed the outcome".

Sara Burns, specialist medical negligence lawyer at Irwin Mitchell, representing the family, said "no amount of compensation can ever begin to make up for what the family has been through".

The health board said changes had been made to reduce the risk of similar incidents in the future.

"We know that no actions can undo what has happened, but we are determined to learn from this case and to continue improving the safety and quality of maternity care for all families across north Wales," it added.`
  },
];

export const gradeCards = [
  {
    id: 1,
    grade: "Grade 6",
    description: "Upper Primary Curriculum",
    path: "/grade6",
    color: "#3B82F6",
    image: grade6Image
  },
  {
    id: 2,
    grade: "Grade 9",
    description: "Junior Secondary",
    path: "/grade9",
    color: "#10B981",
    image: grade9Image
  },
  {
    id: 3,
    grade: "Grade 10",
    description: "Senior Secondary Level 1",
    path: "/grade10",
    color: "#F59E0B",
    image: grade10Image
  },
  {
    id: 4,
    grade: "Grade 11",
    description: "Senior Secondary Level 2",
    path: "/grade11",
    color: "#EF4444",
    image: grade11Image
  },
  {
    id: 5,
    grade: "Grade 12",
    description: "Senior Secondary Level 3",
    path: "/grade12",
    color: "#8B5CF6",
    image: grade12Image
  }
];

export const seoData = {
  title: "CBC Center - Comprehensive Competency Based Curriculum Resources",
  description: "Access free educational materials, resources, and guides for CBC curriculum from Grade 6 to Grade 12. Support your learning journey with quality content.",
  keywords: "CBC resources, Grade 6, Grade 9, Grade 10, Grade 11, Grade 12, competency based curriculum, Kenya education, learning materials"
};

// Add this after the gradeCards array

export const grade6Documents = [
  {
    id: 1,
    Grade: 6,
    year: "2024",
    title: "Mathematics - KPSEA 2024",
    filename: "Mathematics.pdf",
    subject: "Mathematics",
    type: "Past Paper"
  },
  {
    id: 2,
    Grade: 6,
    year: "2024",
    title: "English - KPSEA 2024",
    filename: "English.pdf",
    subject: "English",
    type: "Past Paper"
  },
  {
    id: 3,
    Grade: 6,
    year: "2024",
    title: "Kiswahili - KPSEA 2024",
    filename: "Kiswahili.pdf",
    subject: "Kiswahili",
    type: "Past Paper"
  },
  {
    id: 4,
    Grade: 6,
    year: "2024",
    title: "Creative Arts & Social Studies - KPSEA 2024",
    filename: "Creative Arts & Social Studies.pdf",
    subject: "Creative Arts & Social Studies",
    type: "Past Paper"
  },
  {
    id: 5,
    Grade: 6,
    year: "2024",
    title: "Integrated Science - KPSEA 2024",
    filename: "Intergrated.pdf",
    subject: "Integrated Science",
    type: "Past Paper"
  },
  {
    id: 6,
    year: "2023",
    title: "Creative Arts & Social Studies - KPSEA 2023",
    filename: "KPSEA 2023 CREATIVE ARTS & SOCIAL STUDIES.pdf",
    subject: "Creative Arts & Social Studies",
    type: "Past Paper"
  },
   {
    id: 7,
    Grade: 6,
    year: "2023",
    title: "English - KPSEA 2023",
    filename: "KPSEA 2023 ENGLISH LANGUAGE.pdf",
    subject: "English",
    type: "Past Paper"
  },
  {
    id: 8,
    Grade: 6,
    year: "2023",
    title: "Integrated Science - KPSEA 2023",
    filename: "KPSEA 2023 INTEGRATED SCIENCE.pdf",
    subject: "Integrated Science",
    type: "Past Paper"
  },
  {
    id: 9,
    Grade: 6,
    year: "2023",
    title: "Kiswahili - KPSEA 2023",
    filename: "KPSEA 2023 KISWAHILI LUGHA.pdf",
    subject: "Kiswahili",
    type: "Past Paper"
  },
  {
    id: 10,
    Grade: 6,
    year: "2023",
    title: "Mathematics - KPSEA 2023",
    filename: "KPSEA 2023 MATHEMATICS.pdf",
    subject: "Mathematics",
    type: "Past Paper"
  },
  {
    id: 11,
    Grade: 6,
    year: "2022",
    title: "Mathematics - KPSEA 2022",
    filename: "KPSEA 2022 MATHEMATICS-1.pdf",
    subject: "Mathematics",
    type: "Past Paper",
  },
  {
    id: 12,
    Grade: 6,
    year: "2022",
    title: "English - KPSEA 2022",
    filename: "KPSEA 2022 ENGLISH LANGUAGE-1.pdf",
    subject: "English",
    type: "Past Paper",
  },
  {
    id: 13,
    Grade: 6,
    year: "2022",
    title: "Kiswahili - KPSEA 2022",
    filename: "KPSEA 2022 KISWAHILI LUGHA-1.pdf",
    subject: "Kiswahili",
    type: "Past Paper",
  },
  {
    id: 14,
    Grade: 6,
    year: "2022",
    title: "Integrated Science - KPSEA 2022",
    filename: "KPSEA 2022 INTEGRATED SCIENCE-1.pdf",
    subject: "Integrated Science",
    type: "Past Paper"
  }
];
  export const grade9Documents = [
  
  {
    id: 15,
    Grade: 9,
    year: "2025",
    title: "AGRICULTURE - KJSEA 2025",
    filename: "AGR NUT KJSEA 2025.pdf",
    subject: "Agriculture Nutrition Science",
    type: "Past Paper"
  },
  {
    id: 16,
    Grade: 9,
    year: "2025",
    title: "ENGLISH PP1 KJSEA 2025",
    filename: "ENG KJSEA 2025.pdf",
    subject: "English",
    type: "Past Paper"
  },
  {
    id: 17,
    Grade: 9,
    year: "2025",
    title: "INTEGRATED SCIENCE PP2 KJSEA 2025",
    filename: "INT SCI PP2 KJSEA 2025.pdf",
    subject: "Integrated Science",
    type: "Past Paper"
  },
  {
    id: 18,
    Grade: 9,
    year: "2025",
    title: "KISWAHILI PP1 KJSEA 2025",
    filename: "KIS KJSEA 2025.pdf",
    subject: "Kiswahili",
    type: "Past Paper"
  },
  {
    id: 19,
    Grade: 9,
    year: "2025",
    title: "MATHEMATICS KJSEA 2025",
    filename: "MAT KJSEA 2025.pdf",
    subject: "Mathematics",
    type: "Past Paper"
  },
  {
    id: 20,
    Grade: 9,
    year: "2025",
    title: "PRE-TECHNICAL KJSEA 2025",
    filename: "PRETEC KJSEA 2025.pdf",
    subject: "Pre-Technical Studies",
    type: "Past Paper"
  },
  {
    id: 21,
    Grade: 9,
    year: "2025",
    title: "SOCIAL STUDIES KJSEA 2025",
    filename: "SST 2025 KJSEA.pdf",
    subject: "Social Studies",
    type: "Past Paper"
  },
  {
    id: 22,
    Grade: 9,
    year: "2025",
    title: "AGRICULTURE & NUTR - KJSEA 2025",
    filename: "AGR & NUTR_PP1_Sample_KJSEA.pdf",
    subject: "Agriculture Nutrition Science",
    type: "KJSEA Sample Paper"
  },
  {
    id: 23,
    year: "2025",
    title: "CRA & SPRT PP1 - KJSEA 2025",
    filename: "CRA & SPRT_PP1_Sample_KJSEA.pdf",
    subject: "Creative Arts & Sports",
    type: "KJSEA Sample Paper"
  },
  {
    id: 24,
    year: "2025",
    title: "CRA & SPRT PP2- KJSEA 2025",
    filename: "CRA &SPRT_PP2_Sample_KJSEA.pdf",
    subject: "Creative Arts & Sports",
    type: "KJSEA Sample Paper"
  },
  {
    id: 25,
    year: "2025",
    title: "HRE-KJSEA 2025",
    filename: "HRE_Sample_KJSEA.pdf",
    subject: "HRE",
    type: "KJSEA Sample Paper"
  },
  {
    id: 26,
    year: "2025",
    title: "KENYA SIGN LANGUAGE PP1 2025",
    filename: "KSL_PP1_Sample_KJSEA.pdf",
    subject: "KENYA SIGN LANGUAGE",
    type: "KJSEA Sample Paper"
  },
  {
    id: 27,
    year: "2025",
    title: "KENYA SIGN LANGUAGE PP1 2025",
    filename: "KSL_PP2_Sample_KJSEA.pdf",
    subject: "KENYA SIGN LANGUAGE",
    type: "KJSEA Sample Paper"
  },
  {
    id: 28,
    year: "2025",
    title: "PRE-TECH PP1 KJSEA 2025",
    filename: "PRE-TECH_PP1_Sample_KJSEA.pdf",
    subject: "Pre-Technical Studies",
    type: "KJSEA Sample Paper"
  },
  {
    id: 29,
    year: "2025",
    title: "PRE-TECH PP2 KJSEA 2025",
    filename: "PRE-TECH_PP2_Sample_KJSEA.pdf",
    subject: "Pre-Technical Studies",
    type: "KJSEA Sample Paper"
  },
  {
    id: 30,
    year: "2025",
    title: "SOCIAL STUDIES KJSEA 2025",
    filename: "SST_Sample_KJSEA.pdf",
    subject: "Social Studies",
    type: "KJSEA Sample Paper"
  },
  {
    id: 31,
    year: "2025",
    title: "CRE KJSEA Sample 2025",
    filename: "CRE_Sample_KJSEA.pdf",
    subject: "Christian Religious Education",
    type: "KJSEA Sample Paper"
  },
  {
    id: 32,
    year: "2025",
    title: "ENG PP1 KJSEA Sample 2025",
    filename: "ENG_PP1_Sample_KJSEA.pdf",
    subject: "English",
    type: "KJSEA Sample Paper"
  },
  {
    id: 33,
    year: "2025",
    title: "INTEGRATED SCIENCE PP1 KJSEA Sample 2025",
    filename: "INT_SCI_PP1_Sample_KJSEA.pdf",
    subject: "Integrated Science",
    type: "KJSEA Sample Paper"
  },
  {
    id: 34,
    year: "2025",
    title: "INTEGRATED SCIENCE PP2 KJSEA Sample 2025",
    filename: "INT_SCI_PP2_Sample_KJSEA.pdf",
    subject: "Integrated Science",
    type: "KJSEA Sample Paper"
  },
  {
    id: 35,
    year: "2025",
    title: "IRE KJSEA Sample 2025",
    filename: "IRE_Sample_KJSEA.pdf",
    subject: "IRE",
    type: "KJSEA Sample Paper"
  },
  {
    id: 36,
    year: "2025",
    title: "KISWAHILI LUGHA PP1 KJSEA Sample 2025",
    filename: "KISW_LUGH_PP1_Sample_KJSEA.pdf",
    subject: "Kiswahili",
    type: "KJSEA Sample Paper"
  },
  {
    id: 37,
    year: "2025",
    title: "KISWAHILI LUGHA PP2 KJSEA Sample 2025",
    filename: "KISW_PP2_Sample_KJSEA.pdf",
    subject: "Kiswahili",
    type: "KJSEA Sample Paper"
  },
  {
    id: 38,
    year: "2025",
    title: "Mathematics KJSEA Sample 2025",
    filename: "MATH_KJSEA_Sample.pdf",
    subject: "Mathematics",
    type: "KJSEA Sample Paper"
  },
];

// You can create similar arrays for other grades
export const grade10Documents = [];
export const grade11Documents = [];
export const grade12Documents = [];